class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
    document.body.classList.add('overflow-hidden');   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if(sectionElement){
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }

        if(section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')){
          document.querySelector('#product-page-free-delivery').innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-bubble--mobile'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* HF · Envio por tramos: mantiene al dia las barras de la ficha de producto
   cuando cambia el carrito (anadir, cambiar cantidad o quitar desde el cajon)
   y al volver atras con el navegador. */
(function () {
  var timer = null;

  function refresh() {
    var target = document.getElementById('product-page-free-delivery');
    if (!target) return;
    fetch(window.location.pathname + '?sections=cart-free-delivery', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data && data['cart-free-delivery'];
        if (!html) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) target.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name)) schedule();
        });
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();

/* HF · Regalo del tramo 3: al llegar al importe se anade solo el articulo de
   regalo y, si el carrito baja, se quita. El articulo y el importe los pinta
   snippets/free-delivery-bar.liquid en data-hf-regalo-id / data-hf-regalo-umbral. */
(function () {
  var busy = false, again = false, timer = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function config() {
    var el = document.querySelector('[data-hf-regalo-id]');
    if (!el) return null;
    var id = parseInt(el.getAttribute('data-hf-regalo-id'), 10);
    var umbral = parseInt(el.getAttribute('data-hf-regalo-umbral'), 10);
    return id && umbral > 0 ? { id: id, umbral: umbral } : null;
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) { return response.json(); });
  }

  function repaint() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionsToRender) {
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      return;
    }
    var sections = drawer.getSectionsToRender();
    var ids = sections.map(function (section) { return section.id; }).join(',');
    return fetch(window.location.pathname + '?sections=' + ids, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        sections.forEach(function (section) {
          var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (el && data[section.id]) el.innerHTML = drawer.getSectionInnerHTML(data[section.id], section.selector);
        });
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      });
  }

  function sync() {
    var cfg = config();
    if (!cfg) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var gift = null;
        cart.items.forEach(function (item) { if (item.variant_id === cfg.id) gift = item; });
        if (cart.total_price >= cfg.umbral && !gift) return post('cart/add.js', { items: [{ id: cfg.id, quantity: 1 }] }).then(function () { return true; });
        if (cart.total_price < cfg.umbral && gift) return post('cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return true; });
        if (gift && gift.quantity > 1) return post('cart/change.js', { id: gift.key, quantity: 1 }).then(function () { return true; });
        return false;
      })
      .then(function (changed) { if (changed) return repaint(); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name)) schedule();
        });
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(); });
})();
